import React from "react";
import Button from "@shared/v2/Button";
import ZoomCard from "./shared/ZoomCard";

const PhoneSystemCard = () => (
  <ZoomCard
    actions={
      <Button size="medium" schema="secondary" onClick={() => {}}>
        Get Notified
      </Button>
    }
    title="Phone System"
    comingSoon
    description="Make it easier to connect with your leads, gain insight into your marketing campaigns, and understand your ROI like never before."
    imgSrc="/images/bg-card-phone-system.jpg"
    imgClassName="tw-mt-[24px] tw-ml-[45px] tw-mr-[-12px] tw-rounded-[6px] tw-shadow-md tw-overflow-hidden"
  />
);

export default PhoneSystemCard;
